/* eslint-disable max-statements */
import { combineReducers } from 'redux';
import { ActionType, AppError } from './types';
import { normaliseSearchParams } from 'src/utils/query';
import { DailyQuestType, StakingPlan } from 'src/models';
import { BoxType } from 'src/utils/types';
import merge from 'lodash/merge';
import { CurrencyType } from '@wolffun/system-currency';
const reducers = {
  searchParams: (state = {}, action) => {
    switch (action.type) {
      case ActionType.UPDATE_SEARCH_PARAMS:
        return { ...action.payload.searchParams
        };

      default:
        {
          return state;
        }
    }
  },
  searchResults: (state = {}, action) => {
    const initialSubState = {
      invalidated: true,
      loading: false,
      error: AppError.NO_ERROR
    };

    switch (action.type) {
      case ActionType.FETCH_SEARCH_RESULT_REQUESTED:
        {
          const {
            searchParams
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: true,
              invalidated: true,
              data: undefined
            }
          };
        }

      case ActionType.FETCH_SEARCH_RESULT_SUCCESS:
        {
          const {
            searchParams,
            totalItems
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          const data = new Array(totalItems).fill(null);

          if (subState.data) {
            subState.data.forEach((item, index) => {
              if (index < totalItems) {
                data[index] = item;
              }
            });
          }

          action.payload.data.forEach((item, index) => {
            const idx = (searchParams.from || 0) + index;

            if (idx < totalItems) {
              data[idx] = item;
            }
          });
          return { ...state,
            [query]: { ...subState,
              loading: false,
              invalidated: false,
              error: AppError.NO_ERROR,
              data,
              totalItems
            }
          };
        }

      case ActionType.FETCH_SEARCH_RESULT_FAILURE:
        {
          const {
            searchParams
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: false,
              error: action.payload.error
            }
          };
        }

      default:
        {
          return state;
        }
    }
  },
  searchRentalParams: (state = {}, action) => {
    switch (action.type) {
      case ActionType.UPDATE_SEARCH_RENTAL_PARAMS:
        return { ...action.payload.searchParams
        };

      default:
        {
          return state;
        }
    }
  },
  searchRentalResults: (state = {}, action) => {
    const initialSubState = {
      invalidated: true,
      loading: false,
      error: AppError.NO_ERROR
    };

    switch (action.type) {
      case ActionType.FETCH_SEARCH_RENTAL_RESULT_REQUESTED:
        {
          const {
            searchParams
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: true
            }
          };
        }

      case ActionType.FETCH_SEARCH_RENTAL_RESULT_SUCCESS:
        {
          const {
            searchParams,
            totalItems
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          const data = new Array(totalItems).fill(null);

          if (subState.data) {
            subState.data.forEach((item, index) => {
              if (index < totalItems) {
                data[index] = item;
              }
            });
          }

          action.payload.data.forEach((item, index) => {
            const idx = (searchParams.from || 0) + index;

            if (idx < totalItems) {
              data[idx] = item;
            }
          });
          return { ...state,
            [query]: { ...subState,
              loading: false,
              invalidated: false,
              error: AppError.NO_ERROR,
              data,
              totalItems
            }
          };
        }

      case ActionType.FETCH_SEARCH_RENTAL_RESULT_FAILURE:
        {
          const {
            searchParams
          } = action.payload;
          const query = normaliseSearchParams(searchParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: false,
              error: action.payload.error
            }
          };
        }

      default:
        {
          return state;
        }
    }
  },
  availableHeroInventoryResults: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_AVAILABLE_HERO_INVENTORY_RESULT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_AVAILABLE_HERO_INVENTORY_RESULT_SUCCESS:
        {
          const {
            data,
            totalItems
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data,
            totalItems
          };
        }

      case ActionType.FETCH_AVAILABLE_HERO_INVENTORY_RESULT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimBoxes: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_BOXES_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true,
            data: []
          };
        }

      case ActionType.FETCH_CLAIM_BOXES_SUCCESS:
        {
          const {
            data,
            totalItems
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data,
            totalItems
          };
        }

      case ActionType.FETCH_CLAIM_BOXES_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  itemDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_HERO_DETAIL:
        {
          return { ...state,
            invalidated: true
          };
        }

      case ActionType.FETCH_HERO_DETAIL_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_HERO_DETAIL_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            heroDetail: action.payload.heroDetail
          };
        }

      case ActionType.FETCH_HERO_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  itemUpgradeCost: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HERO_UPGRADE_COST_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_HERO_UPGRADE_COST_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_HERO_UPGRADE_COST_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  upgradeHero: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.UPGRADE_HERO_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.UPGRADE_HERO_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            successItemId: action.payload.successItemId
          };
        }

      case ActionType.UPGRADE_HERO_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  transactionConfirm: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_TRANSACTION_CONFIRM_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_TRANSACTION_CONFIRM_SUCCESS:
        {
          const {
            feeInPercent
          } = action.payload;
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            feeInPercent
          };
        }

      case ActionType.FETCH_TRANSACTION_CONFIRM_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  listNotification: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_LIST_NOTIFICATION_REQUESTED:
        {
          return { ...state,
            loading: true,
            data: { ...state.data,
              callout: undefined
            }
          };
        }

      case ActionType.INVALIDATED_CALLOUT:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: { ...state.data,
              callout: undefined
            }
          };
        }

      case ActionType.FETCH_LIST_NOTIFICATION_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_LIST_NOTIFICATION_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  saleHistoryList: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SALE_HISTORY_LIST_REQUESTED:
        {
          return {
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR,
            data: []
          };
        }

      case ActionType.FETCH_SALE_HISTORY_LIST_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_SALE_HISTORY_LIST_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  itemCheckout: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_CHECKOUT_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            successItemId: undefined
          };
        }

      case ActionType.CHECKOUT_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CHECKOUT_ITEM_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            successItemId: action.payload.id
          };
        }

      case ActionType.CHECKOUT_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  sellItem: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_SELL_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            successItemId: undefined,
            loading: false
          };
        }

      case ActionType.SELL_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.SELL_ITEM_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.SELL_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  saleItemTransaction: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SALE_ITEM_TRANSACTION_CONFIRM_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_SALE_ITEM_TRANSACTION_CONFIRM_SUCCESS:
        {
          const {
            feeInPercent: transactionFee
          } = action.payload;
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            transactionFee
          };
        }

      case ActionType.FETCH_SALE_ITEM_TRANSACTION_CONFIRM_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  paymentToken: (state = {
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_PAYMENT_TOKEN_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_PAYMENT_TOKEN_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_PAYMENT_TOKEN_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  stopSellingItem: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_STOP_SELLING_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            successItemId: undefined,
            loading: false
          };
        }

      case ActionType.STOP_SELLING_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.STOP_SELLING_ITEM_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.STOP_SELLING_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  thetanBoxDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {}
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THETAN_BOX_DETAIL_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_THETAN_BOX_DETAIL_SUCCESS:
        {
          var _newBox, _newBox2;

          const {
            amount,
            boxType,
            boxConfig,
            skinConfigs
          } = action.payload;
          let newBox = state.data[boxType];
          newBox = {
            amount,
            boxConfig: boxConfig ? boxConfig : (_newBox = newBox) === null || _newBox === void 0 ? void 0 : _newBox.boxConfig,
            skinConfigs: skinConfigs ? skinConfigs : (_newBox2 = newBox) === null || _newBox2 === void 0 ? void 0 : _newBox2.skinConfigs
          };
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: { ...state.data,
              [boxType]: newBox
            }
          };
        }

      case ActionType.FETCH_THETAN_BOX_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  userGiftBoxDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      amount: 0,
      isInstalledGame: false,
      openTime: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_USER_GIFT_BOX_DETAIL_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_USER_GIFT_BOX_DETAIL_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload
          };
        }

      case ActionType.FETCH_USER_GIFT_BOX_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  thetanBoxDashboard: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THETAN_BOX_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_THETAN_BOX_DASHBOARD_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_THETAN_BOX_DASHBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftBoxDashboard: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_GIFT_BOX_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_GIFT_BOX_DASHBOARD_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_GIFT_BOX_DASHBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  thetanBoxDashboardDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      [BoxType.COMMON]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      },
      [BoxType.EPIC]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      },
      [BoxType.LEGENDARY]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      },
      [BoxType.SEASON]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      },
      [BoxType.LUNAR]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      },
      [BoxType.SPECIAL]: {
        boxInfo: {
          amount: 0,
          totalAmount: 0,
          boxType: 0,
          systemPrice: {
            token: CurrencyType.THC,
            value: '0'
          },
          isSale: false
        },
        paymentToken: {
          contractAddress: '',
          decimals: 0,
          id: '',
          name: '',
          symbol: ''
        }
      }
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THETAN_BOX_DASHBOARD_DETAIL_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_THETAN_BOX_DASHBOARD_DETAIL_SUCCESS:
        {
          var _state$data, _state$data$boxType, _state$data2, _state$data2$boxType;

          const {
            boxType,
            boxConfig,
            skinConfigs,
            boxInfo,
            paymentToken
          } = action.payload;
          const newBox = {
            boxInfo,
            paymentToken,
            boxConfig: boxConfig || ((_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$boxType = _state$data[boxType]) === null || _state$data$boxType === void 0 ? void 0 : _state$data$boxType.boxConfig),
            skinConfigs: skinConfigs || ((_state$data2 = state.data) === null || _state$data2 === void 0 ? void 0 : (_state$data2$boxType = _state$data2[boxType]) === null || _state$data2$boxType === void 0 ? void 0 : _state$data2$boxType.skinConfigs)
          };
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: { ...state.data,
              [boxType]: newBox
            }
          };
        }

      case ActionType.FETCH_THETAN_BOX_DASHBOARD_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftBoxDashboardDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_GIFT_BOX_DASHBOARD_DETAIL_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_GIFT_BOX_DASHBOARD_DETAIL_SUCCESS:
        {
          const {
            boxInfo
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: boxInfo
          };
        }

      case ActionType.FETCH_GIFT_BOX_DASHBOARD_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  boxConfigs: (state = {
    boxConfigs: {
      [BoxType.COMMON]: {
        boxType: BoxType.COMMON,
        configs: undefined,
        skinIds: []
      },
      [BoxType.EPIC]: {
        boxType: BoxType.EPIC,
        configs: undefined,
        skinIds: []
      },
      [BoxType.LEGENDARY]: {
        boxType: BoxType.LEGENDARY,
        configs: undefined,
        skinIds: []
      },
      [BoxType.SEASON]: {
        boxType: BoxType.SEASON,
        configs: undefined,
        skinIds: []
      }
    }
  }, action) => {
    switch (action.type) {
      case ActionType.SAVE_BOX_CONFIGS:
        return { ...state,
          boxConfigs: action.payload.boxConfigs ? action.payload.boxConfigs : state.boxConfigs
        };

      default:
        return state;
    }
  },
  boxCheckout: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_CHECKOUT_BOX:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            successItemId: undefined
          };
        }

      case ActionType.CHECKOUT_BOX_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CHECKOUT_BOX_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            successItemId: action.payload.id
          };
        }

      case ActionType.CHECKOUT_BOX_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  specialEventConfig: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      eventId: 0,
      eventType: '',
      eventStartIn: 0,
      eventEndIn: 0,
      dailyEventId: 0,
      dailyEventType: '',
      dailyEventStartIn: 0,
      dailyEventEndIn: 0,
      bannerEventUrl: '',
      bannerMobileEventUrl: '',
      listOfRequiredHeroes: [],
      isJoined: false,
      priceTicket: {
        token: CurrencyType.GTHC,
        value: ''
      },
      trophyRequired: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SPECIAL_EVENT_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_CONFIG_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  specialEventLeaderboard: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      entries: [],
      mineLb: null,
      total: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SPECIAL_EVENT_LEADERBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_LEADERBOARD_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_LEADERBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  heroDescriptionConfigs: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    configVer: -1,
    description: undefined,
    reward: {
      win: 0,
      lose: 0,
      draw: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HERO_DESCRIPTION_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_HERO_DESCRIPTION_SUCCESS:
        return { ...state,
          invalidated: false,
          loading: false,
          error: AppError.NO_ERROR,
          configVer: action.payload.configVer ? action.payload.configVer : state.configVer,
          description: action.payload.description ? action.payload.description : state.description,
          reward: action.payload.reward ? action.payload.reward : state.reward
        };

      case ActionType.FETCH_HERO_DESCRIPTION_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      default:
        return state;
    }
  },
  mintConfig: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_MINT_CONFIG_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_MINT_CONFIG_SUCCESS:
        return { ...state,
          invalidated: false,
          loading: false,
          error: AppError.NO_ERROR,
          data: action.payload.data
        };

      case ActionType.FETCH_MINT_CONFIG_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      default:
        return state;
    }
  },
  confirmStake: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.CONFIRM_STAKE_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CONFIRM_STAKE_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.CONFIRM_STAKE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  myStaking: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true,
    data: [],
    summary: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_MY_STAKING_REQUESTED:
        {
          return { ...state,
            loading: true,
            data: []
          };
        }

      case ActionType.FETCH_MY_STAKING_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            summary: action.payload.summary
          };
        }

      case ActionType.FETCH_MY_STAKING_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  signedSignature: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_SIGNED_SIGNATURE:
        {
          return { ...state,
            invalidated: true,
            signature: undefined
          };
        }

      case ActionType.FETCH_SIGNED_SIGNATURE_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_SIGNED_SIGNATURE_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            signature: action.payload.signature
          };
        }

      case ActionType.FETCH_SIGNED_SIGNATURE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  entities: (state = {
    configVer: -1,
    skinVer: -1,
    currencyVer: -1,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SKIN_CONFIGS_REQUESTED:
        return { ...state,
          loading: true
        };

      case ActionType.FETCH_SKIN_CONFIGS_FAILURE:
        return { ...state,
          loading: false,
          error: action.payload.error
        };

      case ActionType.FETCH_SKIN_CONFIGS_SUCCESS:
        return { ...state,
          loading: false,
          error: AppError.NO_ERROR,
          skinConfig: action.payload.data
        };

      case ActionType.ADD_SKIN_CONFIG_ENTITIES:
        {
          const {
            skinConfig
          } = action.payload;
          return { ...state,
            skinConfig: merge(state.skinConfig, skinConfig)
          };
        }
      // case ActionType.ADD_CURRENCY_CONFIG_ENTITIES: {
      //   const { currencyConfig } = action.payload;
      //   return {
      //     ...state,
      //     currencyConfig: merge(state.currencyConfig, currencyConfig),
      //   };
      // }

      case ActionType.SAVE_CONFIG_VER:
        {
          const {
            configVer
          } = action.payload;
          return { ...state,
            configVer
          };
        }
      // case ActionType.SAVE_CURRENCY_VER: {
      //   const { currencyVer } = action.payload;
      //   return {
      //     ...state,
      //     currencyVer,
      //   };
      // }

      case ActionType.SAVE_SKIN_VER:
        {
          const {
            skinVer
          } = action.payload;
          return { ...state,
            skinVer
          };
        }

      default:
        {
          return state;
        }
    }
  },
  unStaking: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    success: false,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATED_UNSTAKING:
        {
          return { ...state,
            success: false,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UNSTAKING_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.UNSTAKING_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      case ActionType.UNSTAKING_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimStakingReward: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    success: false,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATED_CLAIM_STAKING_REWARD:
        {
          return { ...state,
            success: false,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.CLAIM_STAKING_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CLAIM_STAKING_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      case ActionType.CLAIM_STAKING_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  estimateApr: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      [StakingPlan.FLEXIBLE]: 0,
      [StakingPlan.ONE_YEAR]: 0,
      [StakingPlan.SIX_MONTHS]: 0
    },
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_ESTIMATE_APR_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_ESTIMATE_APR_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_ESTIMATE_APR_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  stakingConfig: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true,
    configVer: -1
  }, action) => {
    switch (action.type) {
      case ActionType.STAKING_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.STAKING_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            configVer: action.payload.data.version
          };
        }

      case ActionType.STAKING_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  stakingStats: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.STAKING_STATS_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.STAKING_STATS_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.STAKING_STATS_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  itemRentalConfigs: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true,
    configVer: -1
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_RENTAL_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_RENTAL_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            configVer: action.payload.configVer
          };
        }

      case ActionType.FETCH_RENTAL_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  rentOutItem: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_RENT_OUT_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.RENT_OUT_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.RENT_OUT_ITEM_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.RENT_OUT_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  stopRentOutItem: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_STOP_RENT_OUT_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.STOP_RENT_OUT_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.STOP_RENT_OUT_ITEM_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.STOP_RENT_OUT_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  rentItem: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_RENT_ITEM:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.RENT_ITEM_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.RENT_ITEM_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.RENT_ITEM_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  unlockHeroRental: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_UNLOCK_HERO_RENTAL:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UNLOCK_HERO_RENTAL_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.UNLOCK_HERO_RENTAL_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.UNLOCK_HERO_RENTAL_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  mintHero: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_MINT_HERO:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.MINT_HERO_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.MINT_HERO_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.MINT_HERO_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  mintCosmetic: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_MINT_COSMETIC:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.MINT_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.MINT_COSMETIC_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.MINT_COSMETIC_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  searchCosmeticParams: (state = {}, action) => {
    switch (action.type) {
      case ActionType.UPDATE_SEARCH_COSMETIC_PARAMS:
        return { ...action.payload.searchCosmeticParams
        };

      default:
        {
          return state;
        }
    }
  },
  searchCosmeticResults: (state = {}, action) => {
    const initialSubState = {
      invalidated: true,
      loading: false,
      error: AppError.NO_ERROR
    };

    switch (action.type) {
      case ActionType.FETCH_SEARCH_COSMETIC_LIST_REQUESTED:
        {
          const {
            searchCosmeticParams
          } = action.payload;
          const query = normaliseSearchParams(searchCosmeticParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: true,
              invalidated: true,
              data: undefined
            }
          };
        }

      case ActionType.FETCH_SEARCH_COSMETIC_LIST_SUCCESS:
        {
          const {
            searchCosmeticParams,
            totalItems
          } = action.payload;
          const query = normaliseSearchParams(searchCosmeticParams);
          const subState = state[query] || initialSubState;
          const data = new Array(totalItems).fill(null);

          if (subState.data) {
            subState.data.forEach((item, index) => {
              if (index < totalItems) {
                data[index] = item;
              }
            });
          }

          action.payload.data.forEach((item, index) => {
            const idx = (searchCosmeticParams.from || 0) + index;

            if (idx < totalItems) {
              data[idx] = item;
            }
          });
          return { ...state,
            [query]: { ...subState,
              loading: false,
              invalidated: false,
              error: AppError.NO_ERROR,
              data,
              totalItems
            }
          };
        }

      case ActionType.FETCH_SEARCH_COSMETIC_LIST_FAILURE:
        {
          const {
            searchCosmeticParams
          } = action.payload;
          const query = normaliseSearchParams(searchCosmeticParams);
          const subState = state[query] || initialSubState;
          return { ...state,
            [query]: { ...subState,
              loading: false,
              error: action.payload.error
            }
          };
        }

      default:
        {
          return state;
        }
    }
  },
  boxConfigsV2: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    configVer: -1,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BOX_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_BOX_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            invalidated: false
          };
        }

      case ActionType.FETCH_BOX_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticDetail: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_DETAIL_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_COSMETIC_DETAIL_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_DETAIL_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  sellingCosmetic: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_SELLING_COSMETIC:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.SELLING_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.SELLING_COSMETIC_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.SELLING_COSMETIC_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  stopSellingCosmetic: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_STOP_SELLING_COSMETIC:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.STOP_SELLING_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.STOP_SELLING_COSMETIC_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.STOP_SELLING_COSMETIC_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  purchaseCosmetic: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_PURCHASE_COSMETIC:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.PURCHASE_COSMETIC_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.PURCHASE_COSMETIC_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.PURCHASE_COSMETIC_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticSaleHistory: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR,
    data: [],
    totalItems: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_SALE_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_COSMETIC_SALE_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_SALE_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      default:
        return state;
    }
  },
  specialEventRewards: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SPECIAL_EVENT_REWARDS_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_REWARDS_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_REWARDS_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  tradingEventTurn: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    loadingQuest: {
      [DailyQuestType.SELLER]: false,
      [DailyQuestType.UNBOX]: false
    },
    invalidatedQuest: {
      [DailyQuestType.SELLER]: false,
      [DailyQuestType.UNBOX]: false
    },
    errorQuest: {
      [DailyQuestType.SELLER]: AppError.NO_ERROR,
      [DailyQuestType.UNBOX]: AppError.NO_ERROR
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_TRADING_EVENT_TURN_REQUESTED:
        {
          return { ...state,
            invalidated: false,
            loading: true
          };
        }

      case ActionType.FETCH_TRADING_EVENT_TURN_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_TRADING_EVENT_TURN_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  userRanking: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_USER_RANKING_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_USER_RANKING_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_USER_RANKING_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  joinSpecialEvent: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_JOIN_SPECIAL_EVENT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.FETCH_JOIN_SPECIAL_EVENT_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_JOIN_SPECIAL_EVENT_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  projectDetail: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_PROJECT_DETAIL_REQUESTED:
        {
          return { ...state,
            loading: true,
            data: undefined,
            invalidated: true
          };
        }

      case ActionType.FETCH_PROJECT_DETAIL_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_PROJECT_DETAIL_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  privateSaleConfig: (state = {
    loading: false,
    invalidated: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_PRIVATE_SALE_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            youtubeURL: undefined
          };
        }

      case ActionType.FETCH_PRIVATE_SALE_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_PRIVATE_SALE_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            youtubeURL: action.payload.youtubeURL
          };
        }

      default:
        return state;
    }
  },
  projectList: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_PROJECT_LIST_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_PROJECT_LIST_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_PROJECT_LIST_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  thcExchangeRate: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: {
      rate: 0,
      expiredAt: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THC_EXCHANGE_RATE_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            data: {
              rate: 0,
              expiredAt: 0
            }
          };
        }

      case ActionType.FETCH_THC_EXCHANGE_RATE_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_THC_EXCHANGE_RATE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  buyPrivateSale: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    success: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BUY_PRIVATE_SALE_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true,
            success: false
          };
        }

      case ActionType.FETCH_BUY_PRIVATE_SALE_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_BUY_PRIVATE_SALE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: true
          };
        }

      default:
        return state;
    }
  },
  userProject: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_USER_PROJECT:
        {
          return { ...state,
            invalidated: true,
            data: undefined
          };
        }

      case ActionType.FETCH_USER_PROJECT_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_USER_PROJECT_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_USER_PROJECT_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  fusionCost: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_FUSION_COST_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_FUSION_COST_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_FUSION_COST_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  fuseHero: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.CONFIRM_FUSE_HERO_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.CONFIRM_FUSE_HERO_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.CONFIRM_FUSE_HERO_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  refreshOutputFusion: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.REFRESH_OUTPUT_FUSION_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.REFRESH_OUTPUT_FUSION_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.REFRESH_OUTPUT_FUSION_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  fusionSeason: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_FUSION_SEASON:
        {
          return { ...state,
            invalidated: true,
            data: undefined
          };
        }

      case ActionType.FETCH_FUSION_SEASON_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_FUSION_SEASON_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_FUSION_SEASON_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  previousFusionReward: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_PREVIOUS_FUSION_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CLAIM_PREVIOUS_FUSION_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_PREVIOUS_FUSION_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  fusionLeaderboard: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: {
      entries: [],
      mineLb: null,
      total: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_FUSION_LEADERBOARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_FUSION_LEADERBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_FUSION_LEADERBOARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  fusionTurn: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_FUSION_TURN_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_FUSION_TURN_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_FUSION_TURN_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  battleCapHeroFusion: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined,
    configVer: 7
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_BATTLE_CAP_FUSION_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_BATTLE_CAP_FUSION_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_BATTLE_CAP_FUSION_SUCCESS:
        {
          return { ...state,
            configVer: action.payload.configVer ? action.payload.configVer : state.configVer,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  claimCashback: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_CASHBACK_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_CLAIM_CASHBACK_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_CASHBACK_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  homeBanner: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HOME_BANNER_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_HOME_BANNER_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_HOME_BANNER_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  homeMetricStats: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_METRIC_STATS_DASHBOARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_METRIC_STATS_DASHBOARD_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_METRIC_STATS_DASHBOARD_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  heroesListed: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HEROES_LISTED_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_HEROES_LISTED_DASHBOARD_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_HEROES_LISTED_DASHBOARD_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  heroesTraded: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined,
    totalItems: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_HEROES_TRADED_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_HEROES_TRADED_DASHBOARD_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_HEROES_TRADED_DASHBOARD_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticListed: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_LISTED_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_COSMETIC_LISTED_DASHBOARD_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_LISTED_DASHBOARD_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  cosmeticTraded: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: undefined,
    totalItems: 0
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COSMETIC_TRADED_DASHBOARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_COSMETIC_TRADED_DASHBOARD_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COSMETIC_TRADED_DASHBOARD_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            totalItems: action.payload.totalItems
          };
        }

      default:
        {
          return state;
        }
    }
  },
  specialEventList: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    data: []
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SPECIAL_EVENT_LIST_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_LIST_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_SPECIAL_EVENT_LIST_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  coinbaseLootEventConfigs: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      eventId: 0,
      startIn: 0,
      endIn: 0,
      duration: 0,
      bannerURL: '',
      bannerMobileURL: '',
      bannerDetailURL: '',
      directURLEvent: ''
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_COINBASE_LOOT_EVENT_CONFIGS_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_COINBASE_LOOT_EVENT_CONFIGS_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_COINBASE_LOOT_EVENT_CONFIGS_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        {
          return state;
        }
    }
  },
  tradingEventSeason: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_TRADING_EVENT_SEASON_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_TRADING_EVENT_SEASON_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_TRADING_EVENT_SEASON_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            config: action.payload.config ? action.payload.config : state.config
          };
        }

      default:
        return state;
    }
  },
  claimTradingEventDailyChallenge: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_TRADING_EVENT_DAILY_CHALLENGE_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CLAIM_TRADING_EVENT_DAILY_CHALLENGE_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_TRADING_EVENT_DAILY_CHALLENGE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  claimPreTradingEventDailyReward: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_PRE_TRADING_EVENT_DAILY_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CLAIM_PRE_TRADING_EVENT_DAILY_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_PRE_TRADING_EVENT_DAILY_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  claimTradingEventCashback: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_TRADING_EVENT_CASHBACK_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_CLAIM_TRADING_EVENT_CASHBACK_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_TRADING_EVENT_CASHBACK_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  claimAllTradingEventRewards: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CLAIM_ALL_TRADING_EVENT_REWARDS_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_CLAIM_ALL_TRADING_EVENT_REWARDS_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_CLAIM_ALL_TRADING_EVENT_REWARDS_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  tradingEventLeaderboard: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: {
      entries: [],
      mineLb: null,
      total: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_TRADING_EVENT_LEADERBOARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_TRADING_EVENT_LEADERBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_TRADING_EVENT_LEADERBOARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  previousTradingEventSeason: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_PREVIOUS_TRADING_EVENT_SEASON_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_PREVIOUS_TRADING_EVENT_SEASON_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_PREVIOUS_TRADING_EVENT_SEASON_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            config: action.payload.config ? action.payload.config : state.config
          };
        }

      default:
        return state;
    }
  },
  questConfig: (state = {
    invalidated: false,
    loading: false,
    error: AppError.NO_ERROR,
    data: [],
    rewardConfig: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_QUEST_CONFIG_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_QUEST_CONFIG_FAILURE:
        {
          return { ...state,
            invalidated: true,
            loading: false,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_QUEST_CONFIG_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            data: action.payload.data,
            rewardConfig: action.payload.rewardConfig
          };
        }

      default:
        {
          return state;
        }
    }
  },
  myQuestStages: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: undefined
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_MY_QUEST_STAGES_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_MY_QUEST_STAGES_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_MY_QUEST_STAGES_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  refreshQuest: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.REFRESH_QUEST_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.REFRESH_QUEST_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.REFRESH_QUEST_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimQuestReward: (state = {
    loading: false,
    error: AppError.NO_ERROR,
    invalidated: true
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_QUEST_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.CLAIM_QUEST_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.CLAIM_QUEST_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  claimDailyQuestReward: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    success: false
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_DAILY_QUEST_REWARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.CLAIM_DAILY_QUEST_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.CLAIM_DAILY_QUEST_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      default:
        return state;
    }
  },
  claimWheelTicket: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    success: false
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_WHEEL_TICKET_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.CLAIM_WHEEL_TICKET_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.CLAIM_WHEEL_TICKET_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      default:
        return state;
    }
  },
  claimStreakReward: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    success: false
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_STREAK_REWARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.CLAIM_STREAK_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.CLAIM_STREAK_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      default:
        return state;
    }
  },
  questLeaderboard: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: {
      entries: [],
      mineLb: null,
      total: 0,
      endTime: 0
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_QUEST_LEADERBOARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_QUEST_LEADERBOARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_QUEST_LEADERBOARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  dailyQuestReward: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_DAILY_QUEST_REWARD_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_DAILY_QUEST_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_DAILY_QUEST_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  questBox: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_QUEST_BOX_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.FETCH_QUEST_BOX_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.FETCH_QUEST_BOX_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      default:
        return state;
    }
  },
  claimQuestBox: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    success: false
  }, action) => {
    switch (action.type) {
      case ActionType.CLAIM_QUEST_BOX_REQUESTED:
        {
          return { ...state,
            invalidated: true,
            loading: true
          };
        }

      case ActionType.CLAIM_QUEST_BOX_FAILURE:
        {
          return { ...state,
            loading: false,
            invalidated: true,
            error: action.payload.error
          };
        }

      case ActionType.CLAIM_QUEST_BOX_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            success: action.payload.success
          };
        }

      default:
        return state;
    }
  },
  adsPopupConfig: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_ADS_POPUP_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_ADS_POPUP_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_ADS_POPUP_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  samsungEvent: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_SAMSUNG_EVENT_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_SAMSUNG_EVENT_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_SAMSUNG_EVENT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftmasWheel: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_GIFTMAS_WHEEL_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_GIFTMAS_WHEEL_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_GIFTMAS_WHEEL_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftmasWheelReward: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_WHEEL_REWARD_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_WHEEL_REWARD_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_WHEEL_REWARD_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  giftmasWheelCombineLogo: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_LOGO_COMBINE_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_LOGO_COMBINE_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_LOGO_COMBINE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  thetanWorldConfig: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_THETAN_WORLD_CONFIG_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_THETAN_WORLD_CONFIG_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_THETAN_WORLD_CONFIG_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  }
};
const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  // TODO: try another approach
  // if (action.type === ActionType.USER_SIGN_OUT) {
  //   return appReducer(undefined, action);
  // }
  return appReducer(state, action);
};

export { reducers };
export default rootReducer;